import React, { useState } from "react";
import loadable from "@loadable/component";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/EndPoint";
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import { useForm } from "react-hook-form";
import useGetHook from "../../customHooks/useGetHook";
const CreatePickupNoteComponent = loadable(
  () =>
    import("../../Components/PickupNotes/CreatePickupNote")
);
const CreatePickupNote = () => {
  const {
    data: TrackingNumber,
    isLoading: isdataLoading,
    refetch,
  } = useGetHook({
    queryKey: [`order`],
    url: `${APIS.ORDER}generate-tracking/`,
    params: {},
  });
  
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["pickup-note"],
    navigateURL: "/",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.PICKUP_NOTES;
    const formData = {
      ...values,
      tracking_number:TrackingNumber.tracking_number,
    };
  
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Pickup Note
        </span>
      </div>
      <CreatePickupNoteComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </>
  );
};

export default CreatePickupNote;
